import React,{useContext} from "react";
import heart from "../../../styles/images/png/heart.png";
import {Context} from "../../../_context/Store";


export const UiAdminHeader = () => {

  const [state, dispatch] = useContext(Context);
    return (
        <div className="sbt-admin-header" 
          style={state.ui_sidebar_open ? { marginLeft:'310px'} : { marginLeft:'66px'}}>
          <h1>Admin<img src={heart}/></h1>
          <h2>Create, manage, track</h2>
        </div>
    )
  }
  